// eslint-disable-next-line import/no-duplicates
import { MathfieldElement } from "mathlive";
import "mathlive/fonts.css";
// we have to import like this in order to get the custom element to mount (which appears to be a side effect)
// eslint-disable-next-line import/no-duplicates
import "mathlive";
import React from "react";

import { StyledCommonProps } from "@examspark/common-ui/dist/utils/styled";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "math-field": React.DetailedHTMLProps<
        React.HTMLAttributes<MathfieldElement>,
        MathfieldElement
      >;
    }
  }
}

const MathfieldComponent = (
  props: JSX.IntrinsicElements["math-field"] & {
    mathfieldRef?: React.Ref<MathfieldElement>;
    latex?: string;
  } & StyledCommonProps,
) => {
  const { latex, mathfieldRef, ...rest } = props;
  return (
    <math-field {...rest} ref={mathfieldRef} className={props.className}>
      {latex}
    </math-field>
  );
};

export default MathfieldComponent;
